function getFilterMethod(data, column) {
    switch (column.filterType) {
        case ('string_contains'):
            {
                const casedata = column.value.toLowerCase();
                return data.filter(row => row[column.column_id].toLowerCase().includes(casedata));
            }
        case ('binary_switch'):
            {
                return data.filter(row => row[column.column_id] === column.value - 1);
            }
        case ('array_search'):
            {
                if (column.switchVal) {
                    const checker = (incoming, columnData) => columnData.some(r => incoming.includes(r));
                    return data.filter(row => checker(column.value, row[column.column_id]))
                }
                else {
                    const checker = (incoming, columnData) => incoming.every(i => columnData.includes(i));
                    return data.filter(row => checker(column.value, row[column.column_id]))
                }

            }
        default: return data.filter(row => row[column.column_id].includes(column.value));
    }
}


export function filterList(data, columns) {
    let returnData = data;
    columns.forEach(col => {
        if (col.active) {
            returnData = getFilterMethod(returnData, col)
        }
    });
    return returnData
}

export function checkFilterActive(column) {
    // incase I need to do custom checks for each datatype
    switch (column.filterType) {
        case ('string_contains'):
            {
                if (!column.value) {
                    return false
                }
                return true
            }
        case ('binary_switch'):
            {
                if (Number(column.value) === 0) {
                    return false
                }
                return true
            }
        case ('array_search'):
            {
                if (!column.value.length > 0) {
                    return false
                }
                return true
            }
        default:
            {
                if (!column.value) {
                    return false
                }
                return true
            }
    }
}


// WEBPACK FOOTER //
// src/main/components/tableFilter/TableFilterHelpers.js